module.exports = __webpack_public_path__ + "59d83511c6e2be6032068eeba61435dd.png";